export default {
  saveBtn: { id: 'save_btn' },
  createButton: { id: 'create_button' },
  userInfo: { id: 'user_info' },
  name: { id: 'name' },
  username: { id: 'username' },
  email: { id: 'email' },
  licensee: { id: 'licensees' },
  groups: { id: 'groups' },
  site: { id: 'site' },
  roles: { id: 'roles' },
  locale: { id: 'locale' },
  active: { id: 'active' },
  canCreateOrDelete: { id: 'can_create_delete_jobs' },
  canCreateJobs: { id: 'can_create_jobs' },
  canDeleteJobs: { id: 'can_delete_jobs' },
  canDeleteJobSeries: { id: 'can_delete_job_series' },
  canSeeDeletedJobs: { id: 'can_see_deleted_jobs' },
  canRecoverDeletedJobs: { id: 'can_recover_deleted_jobs' },
  canManageWorkflows: { id: 'can_manage_workflows' },
  validationMessage: { id: 'username_or_email_validation_message' },
  canReopenJobs: { id: 'can_reopen_jobs' },
  canSetSensorsLimits: { id: 'can_set_sensors_limits' },
}
